var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { API_DEFAULT_DOMAIN } from "./index";
import { LANGUAGES } from "../../../constants";
import Lang from "lang.js";
import jsonTranslations from '../../../lang.json';
export var default_settings = {
    bot_id: null,
    enable_contact_us_form: false,
    disable_question_button: false,
    topics: [],
    welcome_message: '',
    category_display_type: 'buttons',
    primary_color: '#fbb41a',
    secondary_color: '#222222',
    categories: [],
    enable_lead_generation: false,
    enable_answer_feedbacks: false,
    enable_contact_button_on_send_form: true,
    enable_contact_button_in_category: false,
    contact_button_text: 'Contact Us',
    contact_button_position: 'bottom',
    contact_us_form_instructions: '',
    chat_starting_position: 'bottom',
    language: LANGUAGES.EN,
    api_url: null,
    response_style: 'box',
    response_style_icon: null
};
export var RESPONSE_STYLE_BOX = 'box';
export var RESPONSE_STYLE_BUBBLE_WITHOUT_LOGO = 'bubble_without_logo';
export var RESPONSE_STYLE_BUBBLE_WITH_LOGO = 'bubble_with_logo';
export var RESPONSE_STYLE_ICON_TRIGGER_ICON = 'trigger_icon';
export var RESPONSE_STYLE_ICON_LOGO = 'logo';
export var CONTACT_BUTTON_POSITION_TOP = 'top';
export var CONTACT_BUTTON_POSITION_BOTTOM = 'bottom';
export var CONFIGURABLE_LOADING_INDICATOR_TYPE_TEXT = 'text';
export var CONFIGURABLE_LOADING_INDICATOR_TYPE_ICON = 'icon';
export var CHAT_STARTING_POSITION_TYPE_BOTTOM = 'bottom';
export var getSettings = function () {
    var _b, _j, _k;
    // @ts-ignore
    var url = new URLSearchParams(window.location.search);
    var language = url.get('language') ? (_b = url.get('language')) === null || _b === void 0 ? void 0 : _b.toLowerCase() : LANGUAGES.EN;
    var apiDomain = url.get('api_domain') ? (_j = url.get('api_domain')) === null || _j === void 0 ? void 0 : _j.toLowerCase() : API_DEFAULT_DOMAIN;
    var currentPageUrl = url.get('current_page_url') ? (_k = url.get('current_page_url')) === null || _k === void 0 ? void 0 : _k.toLowerCase() : null;
    // @ts-ignore
    if (!Object.values(LANGUAGES).includes(language)) {
        language = LANGUAGES.EN;
    }
    var update_settings = window.alwayson_settings || {
        bot_id: window.location.pathname.split('/')[2]
    };
    // @ts-ignore
    update_settings.language = language.toLowerCase();
    update_settings.api_url = window.location.protocol + '//' + apiDomain + '/v1';
    update_settings.current_page_url = currentPageUrl;
    return __assign(__assign({}, default_settings), update_settings);
};
export var getTranslation = function (key) {
    var lang = new Lang({
        messages: jsonTranslations,
        locale: getSettings().language,
        fallback: LANGUAGES.EN
    });
    return lang.get(key);
};
